<template>
	<div id="project-kanban" class="project-kanban-board">
		<div id="kanban-container" class="kanban-rail">
			<section v-if="cards.unknown.length" id="id.unknown" class="kanban-column unknown-column">
				<header class="unknown-header">
					<span class="column-dot"></span>
					<strong>{{ $t('projects.no-status') }}</strong>
					<span>{{ cards.unknown.length }}</span>
				</header>
				<draggable
					:disabled="readOnly"
					id="unknown"
					:list="cards.unknown"
					:group="{ name: 'card', pull: 'clone' }"
					tag="div"
					class="draggable-container"
					:empty-insert-threshold="100"
					:animation="200"
					:handle="$store.state.isMobile ? 'disabled' : '.cardWrapper'"
					ghost-class="ghost"
					:move="cardDragHandler"
					@end="endDragHandler"
				>
					<div
						v-for="deliverable in cards.unknown"
						:key="deliverable.id"
						@click.stop="editDeliverable(deliverable)"
					>
						<kanban-card
							:deliverable="deliverable"
							:assignable-users="assignableUsers"
							:status-list="columns"
							:show-status="false"
							@edit-subtask="editDeliverable($event)"
						></kanban-card>
					</div>
				</draggable>
			</section>

			<section
				v-for="column in columns"
				:id="`id.${column.id}`"
				:key="column.id"
				class="kanban-column"
					:style="{ borderTopColor: column.hexColor || 'var(--portal-border)' }"
			>
				<kanban-header
					:column="column"
					:count="cardCount(column.id)"
					:allow-add-deliverable="hasFullAccessProjects"
					@add-deliverable="addDeliverableNoWait($event)"
				></kanban-header>
				<draggable
					:disabled="readOnly"
					:list="cards['id' + column.id]"
					:group="{ name: 'card', pull: 'clone' }"
					tag="div"
					:empty-insert-threshold="100"
					:animation="200"
					:handle="$store.state.isMobile ? 'disabled' : '.cardWrapper'"
					ghost-class="ghost"
					:class="`draggable-container ${$store.state.isMac ? 'hidden-scroll' : ''}`"
					:move="cardDragHandler"
					@end="endDragHandler"
				>
					<div
						v-for="deliverable in cards['id' + column.id]"
						:key="deliverable.id || 'empty'"
						@click.stop="deliverable.emptyCard ? null : editDeliverable(deliverable)"
					>
						<kanban-card
							:deliverable="deliverable"
							:assignable-users="assignableUsers"
							:status-list="columns"
							@add-new-empty="addDeliverableNoWait(column)"
							@edit-subtask="editDeliverable($event)"
							@add-subtask="addSubTask(deliverable)"
						></kanban-card>
					</div>
				</draggable>
			</section>
		</div>
	</div>
</template>

<script>
	import Draggable from 'vuedraggable';
	import KanbanCard from './KanbanCard';
	import KanbanHeader from './KanbanHeader';

	export default {
		name: 'ProjectKanban',

		props: ['readOnly', 'deliverables', 'updateFlag', 'columns', 'isCollaborator', 'headerHeight','kanbanSort','hasFullAccessProjects','assignableUsers'],

		components: {
			KanbanHeader,
			KanbanCard,
			Draggable,
		},

		data: function() {
			return {
				projectSelectorDialog: false,
				newProjectStatus: null,
				selectedCard: null,
				targetSortIndex: null,
				fromStatusId: null,
				toStatusId: null,

				clickCount: 0,
				clickTimer: null,
			};
		},

		mounted() {

		},

		methods: {
			addDeliverable: function(column) {
				this.clickCount++;
				if (this.clickCount === 1) {
					this.clickTimer = setTimeout(() => {
						this.clickCount = 0;
					}, 500);
					return;
				}

				clearTimeout(this.clickTimer);
				this.clickCount = 0;

				this.$emit('add-deliverable', column);
			},

			addDeliverableNoWait: function(column) {
				this.$emit('add-deliverable', column);
			},

			addSubTask: function(parentTask){
        this.$emit('add-subtask',parentTask);
      },

			cardCount: function(columnId) {
				return this.cards['id' + columnId].filter((card) => !card.emptyCard).length;
			},

			editDeliverable: function(deliverable) {
				this.$emit('edit-deliverable', deliverable);
			},

			cardDragHandler: function(event) {
				if (event.to.parentNode.id === 'unknown') {
					this.selectedCard = null;
					this.targetSortIndex = null;
					return false;
				}

				this.selectedCard = event.draggedContext.element;
				this.targetSortIndex = event.draggedContext.futureIndex;
				return true;
			},

			endDragHandler: function(event) {
				if (this.selectedCard === null) {
					return;
				}

				let updates = [];

				this.fromStatusId = event.from.parentElement.id.split('.')[1];
				this.toStatusId = event.to.parentElement.id.split('.')[1];

				let sortArray = this.cards['id' + this.toStatusId];

				for (let i = 0; i < sortArray.length; i++) {
					if (sortArray[i].kanbanSort !== i || sortArray[i].id === this.selectedCard.id) {
						let update = {
							deliverableId: sortArray[i].id,
							projectId: sortArray[i].project.id,
							kanbanSort: i,
							statusId: this.toStatusId,
							statusLabel: null,
						};

						if (sortArray[i].statusId !== this.toStatusId) {
							update.statusLabel = this.columns.find(s => s.id === this.toStatusId).label;
						}

						updates.push(update);
					}
					sortArray[i].kanbanSort = i;
					sortArray[i].statusId = this.toStatusId;
				}

				this.$emit('update-kanban-props', updates);
        console.log(updates);

				this.updateCounter++;
				this.targetSortIndex = null;
				this.selectedCard = null;
				this.fromStatusId = null;
				this.toStatusId = null;
			},

			cardSort: function(a, b) {
				if (a.kanbanSort !== b.kanbanSort) {
					return a.kanbanSort - b.kanbanSort;
				} else if (a.dueDate && b.dueDate && a.dueDate !== b.dueDate) {
					return Date.parse(a.dueDate) - Date.parse(b.dueDate);
				} else if (a.dueDate && !b.dueDate) {
					return 1;
				} else if (b.dueDate && !a.dueDate) {
					return -1;
				} else {
					if (a.name && b.name) {
						if (a.name.toLowerCase() > b.name.toLowerCase()) {
							return 1;
						} else if (a.name.toLowerCase() < b.name.toLowerCase()) {
							return -1;
						} else {
							return 0;
						}
					} else {
						return 0;
					}
				}
			},

			cardSortDue: function(a, b) {
				if (a.dueDate && b.dueDate && a.dueDate !== b.dueDate) {
					return Date.parse(a.dueDate) - Date.parse(b.dueDate);
				} else if (a.dueDate && !b.dueDate) {
					return -1;
				} else if (b.dueDate && !a.dueDate) {
					return 1;
				} else {
					if (a.name && b.name) {
						if (a.name.toLowerCase() > b.name.toLowerCase()) {
							return 1;
						} else if (a.name.toLowerCase() < b.name.toLowerCase()) {
							return -1;
						} else {
							return 0;
						}
					} else {
						return 0;
					}
				}
			},
		},

		computed: {
			calculatedWidth: function() {
				let count = this.columns.length;
				try {
					return (count + (this.cards.unknown.length > 0 ? 2 : 1)) * 300;
				} catch (e) {
					return 0;
				}
			},

			cards: function() {
				if (this.updateFlag) {
					//do nothing - just reference for updating ui
				}

				let columns = [...this.columns];
				let cards = {
					unknown: [],
				};

				for (let i = 0; i < columns.length; i++) {
					cards['id' + columns[i].id] = [];
				}

				if (this.deliverables.length === 0) {
					let colId = 'id' + columns[0].id;
					cards[colId].push({
						emptyCard: true,
					});
				} else {
					for (let i = 0; i < this.deliverables.length; i++) {
						let colId = 'id' + this.deliverables[i].statusId;
						if (Object.prototype.hasOwnProperty.call(cards, colId)) {
							cards[colId].push(this.deliverables[i]);
						} else {
							cards.unknown.push(this.deliverables[i]);
						}
					}

					for (const key in cards) {
						let arr = cards[key];
						if(this.kanbanSort === 'due'){
							arr.sort(this.cardSortDue);
						}else{
							arr.sort(this.cardSort);
						}

					}
				}

				return cards;
			},
		},
	};
</script>

<style scoped lang="scss">
	.project-kanban-board {
		min-width: 0;
		height: calc(100vh - 290px);
		min-height: 480px;
	}

	.kanban-rail {
		height: 100%;
		display: flex;
		align-items: stretch;
		gap: 14px;
		padding: 0 0 10px;
		overflow-x: auto;
		scroll-snap-type: x proximity;
		user-select: none;
	}

	.kanban-column {
		width: 284px;
		min-width: 284px;
		height: 100%;
		display: flex;
		flex-direction: column;
		border: 1px solid var(--portal-border);
		border-top: 3px solid var(--portal-border);
		border-radius: var(--brand-surface-radius, 15px);
		background: color-mix(in srgb, var(--v-gray_20-base) 60%, var(--portal-surface));
		overflow: hidden;
		scroll-snap-align: start;
	}

	.unknown-column {
		border-top-color: var(--portal-muted);
	}

	.unknown-header {
		min-height: 47px;
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 9px 12px;
	}

	.unknown-header strong {
		min-width: 0;
		flex: 1;
		color: var(--portal-text);
		font-size: 13px;
		font-weight: 750;
	}

	.unknown-header > span:last-child {
		padding: 1px 7px;
		border-radius: 999px;
		background: var(--v-gray_30-base);
		color: var(--portal-muted);
		font-size: 11px;
		font-weight: 700;
	}

	.column-dot {
		width: 9px;
		height: 9px;
		border-radius: 999px;
		background: var(--portal-muted);
	}

	.draggable-container {
		min-height: 80px;
		flex: 1;
		display: flex;
		flex-direction: column;
		gap: 9px;
		padding: 2px 10px 12px;
		overflow-y: auto;
	}

	.ghost {
		opacity: 0.35;
	}

	@media (max-width: 599px) {
		.project-kanban-board {
			height: calc(100vh - 320px);
		}

		.kanban-column {
			width: min(284px, calc(100vw - 54px));
			min-width: min(284px, calc(100vw - 54px));
		}
	}
</style>
